import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CTAButtonProps = {
  label: string;
  note?: string;
  tone?: "light" | "dark";
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  note,
  tone = "light",
  id,
  className = "mt-10"
}: CTAButtonProps) {
  return <div id={id} className={`flex flex-col items-center text-center ${className}`} data-id="element-102" data-mp="2fy0f5mz9spz0">
      <a href={CHECKOUT_URL} className="group flex w-full max-w-xl items-center justify-center gap-3 rounded-2xl bg-cta px-5 py-5 text-[17px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-[0_6px_0_0_#0f6b31,0_16px_28px_-8px_rgba(22,163,74,0.55)] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-cta-hover active:translate-y-[4px] active:shadow-[0_2px_0_0_#0f6b31] focus:outline-none focus-visible:ring-4 focus-visible:ring-gold-300 md:text-xl" data-id="element-103" data-mp="2ty1qjwd5vfsq">
        <span className="text-balance" data-id="element-104" data-mp="38q3imu8zp4i7">{label}</span>
        <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden data-id="element-105" data-mp="199ofghzglbtt" />
      </a>
      {note && <p className={`mt-4 text-sm font-medium ${tone === "dark" ? "text-white/70" : "text-navy-900/60"}`} data-id="element-106" data-mp="1dcb98ofox6tn">{note}</p>}
    </div>;
}